import {SourcingVehicleDetailResponseBody} from '@dms/api/core';
import {OTHER_LEVEL_VALUE} from '@dms/shared';

import {convertMileageToAlphaMileageRange} from '../FullScreenDetailLayout/utils/convertMileageToAlphaMileageRange';

export const getDrillDownSelectedRow = (vehicle?: SourcingVehicleDetailResponseBody) => ({
  make: vehicle?.sourcingVehicle.make?.key,
  model_family_group: vehicle?.sourcingVehicle.modelFamilyGroup?.key,
  model: vehicle?.sourcingVehicle.model?.key,
  year: vehicle?.sourcingVehicle.year?.toString(),
  fuel_type: vehicle?.sourcingVehicle.fuelType?.key,
  drive: vehicle?.sourcingVehicle.driveType?.key,
  transmission: vehicle?.sourcingVehicle.transmission?.key,
  power: vehicle?.sourcingVehicle.power?.toString(),
  mileage_range: convertMileageToAlphaMileageRange(vehicle?.sourcingVehicle.mileage),
  car_style: vehicle?.sourcingVehicle.carStyle?.key,
  vat_reclaimable: vehicle?.sourcingVehicle.price?.vatReclaimable?.toString() ?? OTHER_LEVEL_VALUE,
  number_of_seats: vehicle?.sourcingVehicle.numberOfSeats?.toString() ?? OTHER_LEVEL_VALUE,
  trim_level: vehicle?.sourcingVehicle.trimLevel ?? OTHER_LEVEL_VALUE,
});
